/* global Symbol */

// Note: this module depends on src/component/global/polyfill being loaded

export const PageKind = {
    BSB: Symbol('bsb'),
    Cart: Symbol('cart'),
    Donation: Symbol('donations'),
    GiftCatalogue: Symbol('OGC'),
    Sponsorship: Symbol('sponsorships'),
    Product: Symbol('products'),
    Checkout: Symbol('checkout'),
    CheckoutCard: Symbol('card-customization'),
    Search: Symbol('search'),
    EventsApp: Symbol('eventsapp'),
    KidsCorner: Symbol('kidscorner'),
    PageNotFound: Symbol('404'),
    FAQ: Symbol('FAQ'),
};

export const PAGE_VARS = {
    kind: null,
    action: '',
};
